import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import client from './ApolloClient';
import FullContainer from './views/FullContainer';
import Login from './views/Login';
import Documentation from './views/Docx/Documentation';
import Logout from './views/logout';

const Page404 = () => <h1> Page not found - 404 </h1>;
const Page500 = () => <h1> Page 500 Error </h1>;

class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />
            <Route path="/404" name="Page 404" component={Page404} />
            <Route path="/500" name="Page 500" component={Page500} />
            <Route
              path="/documentation"
              name="Document"
              component={Documentation}
            />
            <Route path="/" name="Home" component={FullContainer} />
          </Switch>
        </BrowserRouter>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js